import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const cmpRecentlyCreatedRoute: InvariantJiraRoute = {
	name: 'software-reports-recently-created-cmp',
	path: '/jira/software/c/projects/:projectKey/boards/:boardId/reports/recently-created',
};
